import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

import { Services } from '../../shared'

export interface VistaExportRange {
    startDate: string
    endDate: string
}

@Component({
    templateUrl: './vista-export-modal.component.html',
    standalone: true,
    imports: [FormsModule],
})
export class VistaExportModalComponent {
    startDate: string
    endDate: string

    constructor(
        private activeModal: NgbActiveModal,
        private services: Services,
    ) {
        const today = new Date()
        const thirtyDaysAgo = new Date()
        thirtyDaysAgo.setDate(today.getDate() - 30)
        this.startDate = this.toInputDate(thirtyDaysAgo)
        this.endDate = this.toInputDate(today)
    }

    export(): void {
        if (!this.startDate || !this.endDate) {
            this.services.notification.warning('Please choose both a start date and an end date.')
            return
        }
        if (this.startDate > this.endDate) {
            this.services.notification.warning('The start date must be on or before the end date.')
            return
        }
        this.activeModal.close({ startDate: this.startDate, endDate: this.endDate } as VistaExportRange)
    }

    cancel(): void {
        this.activeModal.dismiss('cancel')
    }

    private toInputDate(date: Date): string {
        const year = date.getFullYear()
        const month = `${date.getMonth() + 1}`.padStart(2, '0')
        const day = `${date.getDate()}`.padStart(2, '0')
        return `${year}-${month}-${day}`
    }
}
